import React from "react";
import styled from "@emotion/styled";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

// image imports
import TajImage from "../../assets/visionaries/taj.jpeg";
import Custom404 from "../../features/components/custom-404";

// Styled Components
const TopSection = styled.div`
  background: #0984e3;
  min-height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 10px !important;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) 20px
    env(safe-area-inset-left);
`;

const Header = styled.div`
  text-align: center;
  color: white;
  z-index: 1;
  padding: 20px;
  padding-top: max(30px, env(safe-area-inset-top));
  padding-bottom: 0px;
  width: 100%;
  max-width: 600px;
`;

const CTAButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 20px;
`;

const CTAButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 25px;
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`;

const ProfileImg = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 auto 15px;
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const Name = styled.h1`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const BottomSection = styled.div`
  background: #ffffff;
  flex: 1;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

const ContactSection = styled.div`
  margin-bottom: 15px;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 0px 0 0px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  color: #64748b;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const AddContactBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  width: 25px;
  height: 25px;
  background: transparent;
  color: #0984e3;
  border: 1px solid #0984e3;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(9, 132, 227, 0.1);
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  color: #2d3436;

  &:hover {
    background: #e9ecef;
    transform: translateX(5px);
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 25px 0;
`;

const SocialLink = styled.a`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #0984e3;
    color: #fff;
    transform: translateY(-3px);

    i {
      color: #fff;
    }
  }

  i {
    color: #2d3436;
    font-size: 24px;
    transition: color 0.3s ease;
  }
`;

const VCardButton = styled.a`
  display: block;
  width: 90%;
  max-width: 300px;
  margin: 0 auto;
  padding: 15px;
  background: #0984e3;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  text-decoration: none;
  position: relative;

  &:hover {
    background: #0873c4;
    transform: translateY(-2px);
  }

  &.loading {
    color: transparent;
  }
`;

const ShareButton = styled.a`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
  z-index: 2;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }

  i {
    font-size: 18px;
  }
`;

const Loader = styled.div`
  display: none;
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #0984e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  @keyframes spin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
`;

// vcardData.ts or inside the component file
export const contactInfo = [
  {
    visionarieUrl: "taj",
    contacts: [
      {
        name: {
          first: "Taj",
          last: "Rowland",
          full: "Taj Rowland",
        },
        image: TajImage,
        org: "Clinical Visuals",
        title: "Founder",
        phone: "+18013188988",
        email: "taj@clinicalvisuals.com",
        urls: [
          { type: "orgWebsite", url: "https://clinicalvisuals.com/" },
          {
            type: "linkedin",
            url: "https://linkedin.com/in/taj-rowland-bb2311154",
          },
          { type: "website", url: "https://www.theorphankeeper.com/" },
        ],
      },
    ],
  },
];

const BusinessCards: React.FC = () => {
  // Get the current URL path
  const urlPath = window.location.pathname;

  // Split the URL path by '/' and get the last segment
  const pathSegments = urlPath.split("/");
  const lastKey = pathSegments[pathSegments.length - 1];


  const matchedContactGroup = contactInfo.find(
    (item) => item.visionarieUrl === lastKey
  );

  const mainContact = matchedContactGroup?.contacts[0]; // safe access


  const handleVCardDownload = async (
    e: React.MouseEvent<HTMLAnchorElement>,
    visionarieUrl: string | null // Add the visionary URL as an argument
  ) => {
    e.preventDefault();
    const button = e.currentTarget;
    const loader = button.querySelector(".loader") as HTMLElement;

    try {
      button.classList.add("loading");
      if (loader) loader.style.display = "block";

      // Find the contact information based on the URL
      const visionary = contactInfo.find(
        (item) => item.visionarieUrl === visionarieUrl
      );

      if (!visionary) throw new Error("Visionary not found");

      const contact = visionary.contacts[0]; // Assuming one contact per visionary

      // Fetch the image dynamically based on the contact's image field
      const response = await fetch(contact.image, {
        method: "GET",
        cache: "no-store",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
        mode: "cors",
      });

      if (!response.ok) throw new Error("Failed to fetch image");

      const blob = await response.blob();
      const reader = new FileReader();

      reader.onloadend = function () {
        try {
          const base64data = reader.result?.toString().split(",")[1];
          // Create vCard content
          const vcardLines = [
            "BEGIN:VCARD",
            "VERSION:3.0",
            `N:${contact.name.last};${contact.name.first};;;`,
            `FN:${contact.name.full}`,
            `ORG:${contact.org}`,
            `TITLE:${contact.title}`,
            `TEL;TYPE=WORK:${contact.phone}`,
            `EMAIL:${contact.email}`,
            ...contact.urls.map((link) => `URL;type=${link.type}:${link.url}`),
            `PHOTO;ENCODING=BASE64;TYPE=JPEG:${base64data}`,
            "END:VCARD",
          ];

          const vcard = vcardLines.join("\n");

          const downloadVCard = (blobContent: Blob, name: string) => {

            const url = window.URL.createObjectURL(blobContent);
            const tempLink = document.createElement("a");
            tempLink.href = url;
            tempLink.download = name;
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(url);
          };

          if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            const dataUrl = `data:text/x-vcard;charset=utf-8,${encodeURIComponent(
              vcard
            )}`;
            const newWindow = window.open(dataUrl);
            if (!newWindow) window.location.href = dataUrl;
          } else {
            const vcfBlob = new Blob([vcard], {
              type: "text/vcard;charset=utf-8",
            });
            downloadVCard(vcfBlob, contact?.name.full);
          }

          setTimeout(() => {
            button.classList.remove("loading");
            if (loader) loader.style.display = "none";
          }, 500);
        } catch (error) {
          console.error("Error creating vCard:", error);
          button.classList.remove("loading");
          if (loader) loader.style.display = "none";
        }
      };

      reader.onerror = function () {
        console.error("Error reading file:", reader.error);
        button.classList.remove("loading");
        if (loader) loader.style.display = "none";
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error generating vCard:", error);
      button.classList.remove("loading");
      if (loader) loader.style.display = "none";
    }
  };

  const handleShare = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    const shareData = {
      title: "Taj Rowland - Clinical Visuals",
      text: "Connect with Taj Rowland, Founder of Clinical Visuals",
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        const url = encodeURIComponent(window.location.href);
        const text = encodeURIComponent(shareData.text);
        const shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
        window.open(shareUrl, "_blank");
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  return (
    <>
      {mainContact ? (
        <>
          <TopSection>
            <ShareButton href="#" id="shareButton" onClick={handleShare}>
              <ShareRoundedIcon />
            </ShareButton>
            <Header>
              <ProfileImg
                src={mainContact?.image}
                alt={mainContact?.name.full}
              />
              <Name>{mainContact?.name.full}</Name>
              <CTAButtons>
                <CTAButton href={`tel:+${mainContact?.phone}`}>
                  <PhoneRoundedIcon />
                  Call
                </CTAButton>
                <CTAButton href={`mailto:${mainContact?.email}`}>
                  <EmailRoundedIcon />
                  Email
                </CTAButton>
              </CTAButtons>
            </Header>
          </TopSection>

          <BottomSection>
            <ContactSection>
              <SectionHeader>
                <SectionTitle style={{ fontSize: "16px", paddingLeft: "0" }}>
                  Contact Information
                </SectionTitle>
                <AddContactBtn
                  href="#"
                  className="vcard-trigger"
                  onClick={(e) => handleVCardDownload(e, lastKey)}
                >
                  {/* <i className="fas fa-user-plus"></i> */}
                  <PersonAddAltRoundedIcon />
                  <Loader />
                </AddContactBtn>
              </SectionHeader>
              <ContactItem>
                <PhoneRoundedIcon sx={{ color: "#1976d2" }} />
                <a
                  href={`tel:+${mainContact?.phone}`}
                  style={{ color: "#2d3436", textDecoration: "none" }}
                >
                  {mainContact?.phone}
                </a>
              </ContactItem>
              <ContactItem>
                <EmailRoundedIcon sx={{ color: "#1976d2" }} />
                <a
                  href={`mailto:${mainContact?.email}`}
                  style={{ color: "#2d3436", textDecoration: "none" }}
                >
                  {mainContact?.email}
                </a>
              </ContactItem>
              <ContactItem>
                <ApartmentRoundedIcon sx={{ color: "#1976d2" }} />
                <span>{mainContact?.title}</span>
              </ContactItem>
              <ContactItem>
                <LanguageRoundedIcon sx={{ color: "#1976d2" }} />
                {mainContact?.urls &&
                  mainContact.urls.find(
                    (link) => link.type === "orgWebsite"
                  ) && (
                    <a
                      href={
                        mainContact.urls.find(
                          (link) => link.type === "orgWebsite"
                        )?.url
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#2d3436", textDecoration: "none" }}
                    >
                      {mainContact.urls
                        .find((link) => link.type === "orgWebsite")
                        ?.url.replace(
                          /^https?:\/\//,
                          ""
                        ) // This strips the https:// part
                      }
                    </a>
                  )}
              </ContactItem>
            </ContactSection>

            <SocialLinks>
              <SocialLink
                href={
                  mainContact?.urls.find((link) => link.type === "linkedin")
                    ?.url
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon sx={{ color: "#2d3436" }} />
              </SocialLink>
              <SocialLink
                href={
                  mainContact?.urls.find((link) => link.type === "website")?.url
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <LanguageRoundedIcon sx={{ color: "#2d3436" }} />
              </SocialLink>
            </SocialLinks>

            <VCardButton
              href="#"
              onClick={(e) => handleVCardDownload(e, lastKey)}
              download={mainContact?.name.full + ".vcf"}
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <DownloadRoundedIcon
                sx={{
                  color: "#fff",
                  justifyContent: "center",
                  marginRight: "5px",
                  alignItems: "center",
                }}
              />{" "}
              Add to Contacts
              <Loader />
            </VCardButton>
          </BottomSection>
        </>
      ) : (
        <Custom404 />
      )}
    </>
  );
};

export default BusinessCards;
